export default "__VITE_ASSET__CCuuolli__"